import React, { useEffect, useState } from "react";
import {
  ActionIcon,
  Box,
  Menu,
  ScrollArea,
  Table,
  Text,
  createStyles,
} from "@mantine/core";
import { IconEdit, IconEye, IconTrash } from "@tabler/icons-react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { FiExternalLink } from "react-icons/fi";
import RecordNotFound from "../../RecordNotFound";
import TableLoader from "../../TableLoader";
import { useSelector } from "react-redux";
import moment from "moment";
import CustomInvoicePagination from "../../Pagination/CustomInovicePagination";
import { getAllBillingInvoices, getAllBillingInvoicesSkypoint } from "../../../services/billinginvoice";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "#F2F2F2",
      color: "#000 !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "16px !important",
      borderBottomLeftRadius: "16px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "16px !important",
      borderBottomRightRadius: "16px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  tableHeader: {
    borderBottom: "none !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },
  
  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },
}));

const SkypointInvoiceHistory = ({ customer }) => {
  const { classes } = useStyles();
  const [currentPage, setCurrentPage] = useState(1);

  const { allbillinginvoices } = useSelector(
    (state) => state.skypointBillinginvoiceReducer
  );

  useEffect(() => {
    getAllBillingInvoicesSkypoint({ page: currentPage, customerId: customer?.id });
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Format amount with currency symbol
  const formatAmount = (amount) => {
    return `$${amount?.toFixed(2) || "0.00"}`;
  };

  return (
    <>
      <ScrollArea
        sx={{ marginTop: "20px" }}
      >
        <Table
          withBorder
          highlightOnHover
          enableStickyHeader
          sx={{ fontFamily: "Inter", borderRadius: "15px" }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead>
            <tr>
              <th
                style={{ minWidth: "100px", fontWeight: "700" }}
                className={classes.tableHeader}
              >
                Status
              </th>
              <th style={{ minWidth: "120px" }} className={classes.tableHeader}>
                Invoice Id
              </th>
              <th style={{ minWidth: "120px" }} className={classes.tableHeader}>
                Invoice Title
              </th>
              <th style={{ minWidth: "80px" }} className={classes.tableHeader}>
                Date
              </th>
              <th style={{ minWidth: "80px" }} className={classes.tableHeader}>
                Customer Email
              </th>
              <th style={{ minWidth: "120px" }} className={classes.tableHeader}>
                Amount
              </th>
            </tr>
          </thead>

          <tbody>
            {allbillinginvoices?.billinginvoice &&
            allbillinginvoices?.billinginvoice?.length > 0 ? (
              allbillinginvoices?.billinginvoice?.map((row, index) => {
                const bg = index % 2 === 0 ? classes.bg2 : classes.bg1;

                return (
                  <tr key={index} className={bg}>
                    <td>{row?.status}</td>
                    <td>{row?.invoiceNumber}</td>
                    <td>{row?.invoiceTitle}</td>
                    <td>{moment(row?.invoiceDueDate).format("MM/DD/YYYY")}</td>
                    <td>{customer?.email}</td>
                    <td>{formatAmount(row?.totalAmount)}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "75vh",
                      gap: "2rem",
                    }}
                  >
                    <RecordNotFound />
                    <Text className={classes.notFoundText}>
                      No invoices found for this customer
                    </Text>
                  </Box>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <CustomInvoicePagination
          data={allbillinginvoices?.billinginvoice?.length}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </ScrollArea>
    </>
  );
};

export default SkypointInvoiceHistory;
